import { Link } from '@on3/ui-lib/components/Link';
import { useSite } from '@on3/ui-lib/index';
import clsx from 'clsx';
import { useCallback, useMemo, useState } from 'react';

import type { IFrequentQuestionsProps } from './FrequentQuestions';
import styles from './FrequentQuestions.module.scss';

interface IQuestionProps {
  data?: IFrequentQuestionsProps;
}
export const FrequentQuestionsItem = ({ data }: IQuestionProps) => {
  const { question, link, lineOne, linkText, lineTwo } = data || {};
  const { currentSite } = useSite();
  const [open, setOpen] = useState(false);
  const primaryColor = useMemo(
    () => currentSite.linkColor || '#1d252c',
    [currentSite.linkColor],
  );
  const activeColor = '#e4e8f2';

  const handleOpen = useCallback(() => {
    setOpen(true);
  }, []);

  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);
  const handleClick = useCallback(() => {
    if (open) {
      handleClose();
    } else {
      handleOpen();
    }
  }, [handleClose, handleOpen, open]);

  return (
    <li className={styles.faqItem}>
      <button
        onClick={handleClick}
        style={{
          color: open ? '#1d252c' : primaryColor,
          backgroundColor: open ? `${primaryColor}33` : '',
        }}
      >
        <span>{question}</span>
        <span className={styles.plusMinus}>{open ? '-' : '+'}</span>
      </button>
      {open && (
        <p className={styles.answerContainer}>
          <span>
            <span>{lineOne}</span>
            {linkText && (
              <Link
                className={styles.link}
                href={link}
                style={{ color: primaryColor }}
              >
                {linkText}
              </Link>
            )}
          </span>
          {lineTwo && <span>{lineTwo}</span>}
        </p>
      )}
    </li>
  );
};
